module.exports = __webpack_public_path__ + "static/media/art27.47ea5f83.jpg";